<script>
import FireEx from "../../../include/FireEx";

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        products: {
            type: Array,
            required: true
        }
    },
    computed: {
        showExpiryNote: function () {
            return FireEx.showExpiryNote(this.item, this.products);
        },
    }
}
</script>

<template>
    <p
        class="expiry-notice"
        v-if="showExpiryNote"
    >
        <i class="fas fa-stopwatch" />
        Expires in next 12 months
    </p>
</template>

<style scoped lang="scss">
.expiry-notice {
    margin: 1px;
    color: red;
    font-size: .8em;
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/office/service-products/ExpiryNotice.vue